"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var edge_1 = require("./common/edge");

var utils_1 = require("../../../utils");

var edge_clamped_vert_glsl_1 = __importDefault(require("../shaders/edge.clamped.vert.glsl.js"));

var edge_frag_glsl_1 = __importDefault(require("../shaders/edge.frag.glsl.js"));

var POINTS = 4,
    ATTRIBUTES = 6,
    STRIDE = POINTS * ATTRIBUTES;

var EdgeClampedProgram =
/** @class */
function (_super) {
  __extends(EdgeClampedProgram, _super);

  function EdgeClampedProgram(gl) {
    var _this = _super.call(this, gl, edge_clamped_vert_glsl_1.default, edge_frag_glsl_1.default, POINTS, ATTRIBUTES) || this; // Initializing indices buffer


    var indicesBuffer = gl.createBuffer();
    if (indicesBuffer === null) throw new Error("EdgeClampedProgram: error while getting resolutionLocation");
    _this.indicesBuffer = indicesBuffer; // Locations:

    _this.positionLocation = gl.getAttribLocation(_this.program, "a_position");
    _this.colorLocation = gl.getAttribLocation(_this.program, "a_color");
    _this.normalLocation = gl.getAttribLocation(_this.program, "a_normal");
    _this.radiusLocation = gl.getAttribLocation(_this.program, "a_radius"); // Uniform locations

    var matrixLocation = gl.getUniformLocation(_this.program, "u_matrix");
    if (matrixLocation === null) throw new Error("EdgeClampedProgram: error while getting matrixLocation");
    _this.matrixLocation = matrixLocation;
    var sqrtZoomRatioLocation = gl.getUniformLocation(_this.program, "u_sqrtZoomRatio");
    if (sqrtZoomRatioLocation === null) throw new Error("EdgeClampedProgram: error while getting cameraRatioLocation");
    _this.sqrtZoomRatioLocation = sqrtZoomRatioLocation;
    var correctionRatioLocation = gl.getUniformLocation(_this.program, "u_correctionRatio");
    if (correctionRatioLocation === null) throw new Error("EdgeClampedProgram: error while getting viewportRatioLocation");
    _this.correctionRatioLocation = correctionRatioLocation; // Enabling the OES_element_index_uint extension
    // NOTE: on older GPUs, this means that really large graphs won't
    // have all their edges rendered. But it seems that the
    // `OES_element_index_uint` is quite everywhere so we'll handle
    // the potential issue if it really arises.
    // NOTE: when using webgl2, the extension is enabled by default

    _this.canUse32BitsIndices = (0, utils_1.canUse32BitsIndices)(gl);
    _this.IndicesArray = _this.canUse32BitsIndices ? Uint32Array : Uint16Array;
    _this.indicesArray = new _this.IndicesArray();
    _this.indicesType = _this.canUse32BitsIndices ? gl.UNSIGNED_INT : gl.UNSIGNED_SHORT;

    _this.bind();

    return _this;
  }

  EdgeClampedProgram.prototype.bind = function () {
    var gl = this.gl;
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indicesBuffer); // Bindings

    gl.enableVertexAttribArray(this.positionLocation);
    gl.enableVertexAttribArray(this.normalLocation);
    gl.enableVertexAttribArray(this.colorLocation);
    gl.enableVertexAttribArray(this.radiusLocation);
    gl.vertexAttribPointer(this.positionLocation, 2, gl.FLOAT, false, ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT, 0);
    gl.vertexAttribPointer(this.normalLocation, 2, gl.FLOAT, false, ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT, 8);
    gl.vertexAttribPointer(this.colorLocation, 4, gl.UNSIGNED_BYTE, true, ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT, 16);
    gl.vertexAttribPointer(this.radiusLocation, 1, gl.FLOAT, false, ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT, 20);
  };

  EdgeClampedProgram.prototype.process = function (sourceData, targetData, data, hidden, offset) {
    if (hidden) {
      for (var i_1 = offset * STRIDE, l = i_1 + STRIDE; i_1 < l; i_1++) {
        this.array[i_1] = 0;
      }

      return;
    }

    var thickness = data.size || 1,
        x1 = sourceData.x,
        y1 = sourceData.y,
        x2 = targetData.x,
        y2 = targetData.y,
        radius = targetData.size || 1,
        color = (0, utils_1.floatColor)(data.color); // Computing normals

    var dx = x2 - x1,
        dy = y2 - y1;
    var len = dx * dx + dy * dy,
        n1 = 0,
        n2 = 0;

    if (len) {
      len = 1 / Math.sqrt(len);
      n1 = -dy * len * thickness;
      n2 = dx * len * thickness;
    }

    var i = POINTS * ATTRIBUTES * offset;
    var array = this.array; // First point

    array[i++] = x1;
    array[i++] = y1;
    array[i++] = n1;
    array[i++] = n2;
    array[i++] = color;
    array[i++] = 0; // First point flipped

    array[i++] = x1;
    array[i++] = y1;
    array[i++] = -n1;
    array[i++] = -n2;
    array[i++] = color;
    array[i++] = 0; // Second point

    array[i++] = x2;
    array[i++] = y2;
    array[i++] = n1;
    array[i++] = n2;
    array[i++] = color;
    array[i++] = radius; // Second point flipped

    array[i++] = x2;
    array[i++] = y2;
    array[i++] = -n1;
    array[i++] = -n2;
    array[i++] = color;
    array[i] = -radius;
  };

  EdgeClampedProgram.prototype.computeIndices = function () {
    var l = this.array.length / ATTRIBUTES;
    var size = l + l / 2;
    var indices = new this.IndicesArray(size);

    for (var i = 0, c = 0; i < l; i += 4) {
      indices[c++] = i;
      indices[c++] = i + 1;
      indices[c++] = i + 2;
      indices[c++] = i + 2;
      indices[c++] = i + 1;
      indices[c++] = i + 3;
    }

    this.indicesArray = indices;
  };

  EdgeClampedProgram.prototype.bufferData = function () {
    _super.prototype.bufferData.call(this); // Indices data


    var gl = this.gl;
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indicesArray, gl.STATIC_DRAW);
  };

  EdgeClampedProgram.prototype.render = function (params) {
    if (this.hasNothingToRender()) return;
    var gl = this.gl;
    var program = this.program;
    gl.useProgram(program); // Binding uniforms

    gl.uniformMatrix3fv(this.matrixLocation, false, params.matrix);
    gl.uniform1f(this.sqrtZoomRatioLocation, Math.sqrt(params.ratio));
    gl.uniform1f(this.correctionRatioLocation, params.correctionRatio); // Drawing:

    gl.drawElements(gl.TRIANGLES, this.indicesArray.length, this.indicesType, 0);
  };

  return EdgeClampedProgram;
}(edge_1.AbstractEdgeProgram);

exports.default = EdgeClampedProgram;